import type React from 'react';
import type { MessageAttachment } from '@wix/ai-scheduling-assistant-common-lib/entities';
import { extensionOf, humanSize, typeLabel } from '../../../../lib/artifact-file';
import { attachmentAsFile } from './AttachmentGraphic';

/** The filename over what the file IS: "Markdown", "PDF · 394 KB". The second line is what the chip was
 *  missing — a name alone makes every attachment look identical until you open it. Each part is dropped
 *  when unknown rather than guessed, so a file with no recorded size simply shows its type. */
export function AttachmentLabel({ att, content }: { att: MessageAttachment; content: string }) {
  const item = attachmentAsFile(att, content);
  const type = typeLabel(extensionOf(item));
  const size = item.sizeBytes ? Number(item.sizeBytes) : null;
  const meta = [type, size && size > 0 ? humanSize(size) : null].filter(Boolean).join(' \u00b7 ');
  return (
    <span style={styles.label}>
      <span style={styles.labelName}>{att.fileName}</span>
      {meta && <span style={styles.labelMeta}>{meta}</span>}
    </span>
  );
}

const styles = {
  label: { display: 'flex', flexDirection: 'column', gap: 1, minWidth: 0, overflow: 'hidden' } satisfies React.CSSProperties,
  labelName: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontWeight: 'var(--sym-weight-medium)',
  } satisfies React.CSSProperties,
  labelMeta: {
    fontSize: 11,
    lineHeight: '14px',
    color: 'rgba(var(--ink-rgb), 0.55)',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  } satisfies React.CSSProperties,
};
